export default function OwnerStatement() {
  return (
    <section id="about" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-2">
            <div className="relative">
              <div className="w-full h-96 rounded-3xl overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/ba6bcb6e46a4fb76c5fa17ca5b486c21/8f6c5aa69ba68d8fbfb4f1f984c38186.jpeg"
                  alt="Owner Gary McCrea"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute bottom-6 right-6 px-4 py-2 bg-white rounded-full text-sm font-medium text-gray-900 shadow-lg">
                Owner & Founder
              </div>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="text-emerald-600 font-semibold tracking-wider text-sm uppercase mb-6">
              ABOUT MCCREA'S
            </div>
            <div className="relative mb-8">
              <i className="ri-double-quotes-l text-6xl text-emerald-600 absolute -left-4 -top-4 opacity-20"></i>
              <p className="text-3xl lg:text-4xl font-serif text-gray-900 leading-relaxed relative z-10">
                At McCrea's, we believe every outdoor space has the potential to become something extraordinary. For almost two decades, we've been transforming properties with dedication, expertise, and a genuine passion for creating landscapes that our clients love.
              </p>
            </div>
            <div className="flex items-center space-x-3 mb-8">
              <div className="font-bold text-xl text-gray-900">Gary McCrea</div>
              <div className="w-6 h-6 flex items-center justify-center bg-emerald-600 rounded-full">
                <i className="ri-check-line text-white text-sm"></i>
              </div>
              <div className="text-gray-600">Google Reviews</div>
            </div>
            <div className="grid grid-cols-2 gap-8">
              <div>
                <div className="text-5xl font-bold text-emerald-600 mb-2">30+</div>
                <div className="text-gray-600">Years Experience</div>
              </div>
              <div>
                <div className="text-5xl font-bold text-emerald-600 mb-2">500+</div>
                <div className="text-gray-600">Projects Completed</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}